/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { captureException } from '@sentry/react';
import connectwiseHostedAPI from '../services/connectWiseHostedAPI';
import {
  getConnectwiseAuthToken,
  requestToAccessToken
} from '../services/connectWiseHostedAPI/utils';
import { getUrlParam } from '../utils';

export default function useConnectWiseAuth({
  onSuccess,
  maxRetryCount = 3,
  incrementalTimeout = 1000
} = {}) {
  const appId = getUrlParam('appId');
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (getUrlParam('callback')) {
      const res = getConnectwiseAuthToken({
        appId,
        callbackUrl: getUrlParam('callback')
      }).then(token => {
        onSuccess({ token: token.access_token, appId });
        setErrorMessage('');
        setIsLoading(false);
      });
    } else {
      connectwiseHostedAPI.initialize();
      requestToAccessToken({ appId, maxRetryCount, incrementalTimeout })
        .then(token => {
          onSuccess({ token, appId });
          setErrorMessage('');
          setIsLoading(false);
        })
        .catch(err => {
          const message = `Failed to authenticate through ConnectWise: ${
            err?.response?.data?.message || err?.message
          }`;

          captureException(new Error(message), {
            tags: {
              appId
            }
          });
          setIsLoading(false);
          setErrorMessage(message);
        });
    }
  }, []);

  return { loading: isLoading, errorMessage };
}
